import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadLinkHandlerService {
  private isDownloadClick = false;

  /**
   * Check if a click event is on a download or external link
   */
  handleClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a');

    if (anchor && anchor.href) {
      const url = anchor.href;
      const currentOrigin = window.location.origin;

      // Check if this is a download link or external link
      if (this.isDownloadOrExternalLink(anchor, url, currentOrigin)) {
        this.isDownloadClick = true;
        return;
      }
    }
    this.isDownloadClick = false;
  }

  /**
   * Check if the current action is a download click
   */
  isDownload(): boolean {
    return this.isDownloadClick;
  }

  /**
   * Reset the download click flag
   * Should be called in onBeforeUnload when download is detected
   */
  reset(): void {
    this.isDownloadClick = false;
  }

  /**
   * Determine if a link is a download or external link
   */
  private isDownloadOrExternalLink(
    anchor: HTMLAnchorElement,
    url: string,
    currentOrigin: string,
  ): boolean {
    return (
      !url.startsWith(currentOrigin) ||
      anchor.getAttribute('download') !== null ||
      anchor.target === '_blank' ||
      // Check for media service endpoints (images and documents)
      url.includes('/media/questmedia.ashx') ||
      // Check for common download file extensions
      /\.(pdf|doc|docx|xls|xlsx|zip|rar|jpg|jpeg|png|gif|csv|txt|ppt|pptx)$/i.test(
        url,
      )
    );
  }
}
